import React from 'react';
import { Calendar } from 'primereact/calendar';
import PropTypes from 'prop-types';

const CalendarPM = ({
  value = null,
  onChange = null,
  minDate = null,
  maxDate = null,
  monthNavigator = false,
  yearNavigator = false,
  yearRange = '',
  className = '',
}) => {
  CalendarPM.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    monthNavigator: PropTypes.bool,
    yearNavigator: PropTypes.bool,
    yearRange: PropTypes.string,
    className: PropTypes.string,
  };

  return (
    <div className={`Calendar ${className}`}>
      <Calendar
        minDate={minDate}
        maxDate={maxDate}
        monthNavigator={monthNavigator}
        yearNavigator={yearNavigator}
        yearRange={yearRange}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default CalendarPM;